import {
  PostLoanApplicationPayload,
  PostLoanApplicationResponse,
} from 'types/webApi';
import fetchWebApi from 'api/fetchWebApi';

const postLoanApplicationApiCall = async (
  payload: PostLoanApplicationPayload,
): Promise<PostLoanApplicationResponse> =>
  fetchWebApi('/client/application', undefined, {
    method: 'post',
    body: JSON.stringify(payload),
  });

export default postLoanApplicationApiCall;
